import { useContext } from "react";
import { Users } from "src/context";
import { Processor } from "./Processor";

let state = null;

const IsEnabled = () => {
  const { userIntegrations } = useContext(Users);
  const active_integrations = userIntegrations ?? [];

  if (active_integrations.length === 0) return false;

  const check = active_integrations.filter((x) => x.id === 18);
  if (check.length > 0 && check?.[0]?.user_integrations === "active") {
    return true;
  }

  return false;
};

const getComponent = () => {
  return () => <h1>DocuSign</h1>;
};

const getConfig = () => {
  return {
    name: "docusign",
    type: "contract",
    data: state,
  };
};

const updateData = (data) => {
  state = data;
};

const useProcessor = (user) => {
  return new Processor(user);
};

const isActiveInpackage = (_package) => {
  const contractConfig = _package?.options?.contract_config?.docusign;
  const config = contractConfig ?? {};
  const hasConfig = Object.keys(config).length > 0;
  return {
    docusign: {
      active: hasConfig,
      template_id: config?.template_id ?? "",
    },
  };
};

export default {
  IsEnabled,
  getConfig,
  getComponent,
  updateData,
  useProcessor,
  isActiveInpackage,
};
